import { useCallback, useEffect, useRef, useState } from "react";

// animationend 대신 타이머로 해제한다 — prefers-reduced-motion 환경에서는
// 애니메이션이 실행되지 않아 animationend가 발화하지 않기 때문이다.
export const useShake = (durationMs = 600) => {
  const [isShaking, setIsShaking] = useState(false);
  const timerRef = useRef<number>();

  useEffect(() => () => window.clearTimeout(timerRef.current), []);

  const triggerShake = useCallback(() => {
    setIsShaking(true);
    window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => setIsShaking(false), durationMs);
  }, [durationMs]);

  return { isShaking, triggerShake };
};
